"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBar = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
function TabBar(_a) {
    var children = _a.children, csx = _a.csx;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { as: "nav", sx: __assign({ position: "relative", "::before": {
                background: theme_1.theme.colors.grey900,
                bottom: 0,
                content: "''",
                height: "2px",
                left: 0,
                position: "absolute",
                width: "100%"
            } }, csx) }, children));
}
exports.TabBar = TabBar;
